import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';
import { BREAKPOINTS } from 'admin/utils/breakpoints';

export const LeftSideHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 369px;
  height: 100vh;
  background: ${COLORS.darkMainColor};

  @media only screen and ${BREAKPOINTS.laptop} {
    align-items: center;
    position: unset;
    justify-content: center;
    width: 100%;
    height: 60px;
    min-height: unset;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  padding-left: 62px;
  padding-top: 34px;

  @media only screen and ${BREAKPOINTS.laptop} {
    flex-direction: row;
    align-items: center;
    height: 50px;
    width: 100%;
    padding: unset;
  }
`;

export const LogoAndHamburger = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;

  @media only screen and ${BREAKPOINTS.laptop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 34px;
    padding-right: 34px;
  }
`;

export const ItahLogo = styled.img`
  cursor: pointer;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  height: auto;

  @media only screen and ${BREAKPOINTS.laptop} {
    position: absolute;
    top: 55px;
    left: ${({ burgerMenu }) => (burgerMenu ? 0 : '-100%')};
    display: ${({ burgerMenu }) => (burgerMenu ? 'block' : 'none')};
    height: 100%;
    width: 100%;
    margin-top: unset;
    background: ${COLORS.darkMainColor};
    z-index: 10;
  }
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 20px;

  @media only screen and ${BREAKPOINTS.laptop} {
    align-items: center;
    gap: 60px;
    height: 100%;
  }
`;

export const HeaderList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  cursor: pointer;

  @media only screen and ${BREAKPOINTS.laptop} {
    width: 130px;
  }
`;

export const ListImage = styled.img``;

export const HeaderTitleLists = styled.li`
  list-style: none;
  ${FONTS.font18};
  color: ${COLORS.white};
`;

export const HamburgerMenu = styled.img`
  width: 24px;
  cursor: pointer;
  display: none;

  @media only screen and ${BREAKPOINTS.laptop} {
    display: block;
  }
`;

export const AdminInfo = styled.div`
  display: ${({ isMobile }) => (isMobile ? 'none' : 'flex')};
  align-items: center;
  position: relative;
  gap: 10px;
  width: 100%;
  height: 106px;
  padding-left: 62px;
  border-top: 2px solid ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.laptop} {
    display: ${({ isMobile }) => (isMobile ? 'flex' : 'none')};
    justify-content: center;
  }
`;

export const UserInfo = styled.div`
  display: ${({ isMobile }) => (isMobile ? 'none' : 'flex')};
  align-items: center;
  position: relative;
  gap: 10px;
  width: 100%;
  height: 106px;
  padding-left: 62px;
  border-top: 2px solid ${COLORS.lightSilver};

  @media only screen and ${BREAKPOINTS.laptop} {
    display: ${({ isMobile }) => (isMobile ? 'flex' : 'none')};
    justify-content: center;
  }
`;

export const UserPicture = styled.img`
  width: 46px;
  height: 46px;
`;

export const NameAndEmail = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 2px;
  width: auto;
  height: auto;
`;

export const UserName = styled.span`
  color: ${COLORS.white};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SampleModalWrapper = styled.div`
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 316px;
  flex-shrink: 0;

  @media only screen and ${BREAKPOINTS.laptop} {
    position: absolute;
    left: 520px;
    bottom: 100px;
  }
`;

export const UserEmail = styled.span`
  ${FONTS.font14};
  ${FONT_FAMILY.FontRegular};
  color: ${COLORS.white};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const RightVector = styled.img`
  cursor: pointer;
  margin-right: 30px;
`;
